<!--接口管理-->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        class="ant-advanced-search-form"
        layout="inline"
        :form="form"
        @submit="handleSearch"
      >
        <a-row :gutter="24">
          <a-col :md="8" :sm="8">
            <a-form-item label="服务名称">
              <a-input
                placeholder="请输入服务名称"
                v-model="queryParam.serviceName"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="8">
            <a-form-item label="接口名称">
              <a-input
                placeholder="请输入接口名称"
                v-model="queryParam.interfaceName"
              ></a-input>
            </a-form-item>
          </a-col>
          <template v-if="expand">
            <a-col :md="8" :sm="8">
              <a-form-item label="接口地址">
                <a-input
                  placeholder="请输入接口地址"
                  v-model="queryParam.interfacePath"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="8">
              <a-form-item label="接口描述">
                <a-input
                  placeholder="请输入接口描述"
                  v-model="queryParam.interfaceDesc"
                ></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="8" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleSearch" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="handleReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="toggle" style="margin-left: 8px">
                {{ expand ? '收起' : '展开' }}
                <a-icon :type="expand ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" @click="handleUpdate">更新接口数据</a-button>
    </div>

    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        size="middle"
        bordered
        :columns="columns"
        :data-source="dataList"
        rowKey="id"
        :scroll="{ x: 1000 }"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
      >
        <span slot="appNum" slot-scope="text, record">
          <a @click="getAuthorized(record)">{{ text }}</a>
        </span>
      </a-table>
    </div>
    <authorized-modal ref="authorized"></authorized-modal>
  </a-card>
</template>

<script>
const columns = [
  {
    align: 'center',
    title: '服务',
    dataIndex: 'serviceName',
    width: 200,
  },
  {
    align: 'center',
    title: '接口名',
    dataIndex: 'interfaceName',
    width: 200,
  },
  {
    align: 'center',
    title: '接口地址',
    dataIndex: 'interfacePath',
    width: 200,
  },
  {
    align: 'center',
    title: '接口描述',
    dataIndex: 'interfaceDesc',
    width: 200,
    customRender: (text) => {
      return !text || text == '' ? '--' : text;
    },
  },
  {
    align: 'center',
    title: '已授权应用数',
    dataIndex: 'appNum',
    width: 200,
    scopedSlots: {
      customRender: 'appNum',
    },
  },
  // {
  //   align: 'center',
  //   title: '操作',
  //   key: 'operation',
  //   width: 200,
  //   scopedSlots: {
  //     customRender: 'operation'
  //   }
  // }
];
import authorizedModal from './authorizedModal';
import { getAction } from '@/api/manage';
export default {
  data() {
    return {
      ipagination: {
        //分页参数
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      columns,
      form: this.$form.createForm(this),
      expand: false,
      selectedRowKeys: [],
      selectedRows: [],
      dataList: [],
      loading: false,
      url: {
        list: process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/interface/page',
        update:
          process.env.VUE_APP_CMS_SYSTEM + '/sys/auth/interface/saveOrUpdate',
      },
      queryParam: {
        interfaceDesc: '',
        interfaceName: '',
        interfacePath: '',
        serviceName: '',
      },
    };
  },
  components: {
    authorizedModal,
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData(arg) {
      if (arg == 1) {
        this.ipagination.current = 1;
      }
      let params = {
        ...this.queryParam,
        pageNo: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
      };
      this.loading = true;
      getAction(this.url.list, params).then((res) => {
        this.loading = false;
        if (res.success) {
          this.dataList =
            res.result && res.result.records ? res.result.records : [];
          this.ipagination.total = res.result ? res.result.total : 0;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSearch() {
      this.initData(1);
    },
    handleReset() {
      this.queryParam = {
        interfaceDesc: '',
        interfaceName: '',
        interfacePath: '',
        serviceName: '',
      };
      this.initData(1);
    },
    toggle() {
      this.expand = !this.expand;
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRows = selectionRows;
      this.selectedRowKeys = selectedRowKeys;
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected();
      this.ipagination = pagination;
      this.initData();
    },
    getAuthorized(record) {
      this.$refs.authorized.checkApp();
      this.$refs.authorized.initData(record);
    },
    handleUpdate() {
      this.loading = true;
      getAction(this.url.update, {}).then((res) => {
        console.log('**********', res);
        this.ipagination.current = 1;
        if (res.success) {
          this.$message.success('更新成功');
          this.initData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.table-operator {
  margin-bottom: 10px;
}
</style>
